export const USER_ROLE = {
  USER: 'USER',
  TENANT_ADMIN: 'TENANT_ADMIN',
  PROJECT_ADMIN: 'PROJECT_ADMIN',
  PLATFORM_ADMIN: 'PLATFORM_ADMIN',
} as const;

export type UserRole = (typeof USER_ROLE)[keyof typeof USER_ROLE];

export function isTenantAdmin(role: string | undefined): boolean {
  return role === USER_ROLE.TENANT_ADMIN || role === USER_ROLE.PLATFORM_ADMIN;
}
